import Select from "react-select";
import maleTeacher from "../../../assets/png/male-teacher-profile.png";
import { BoardAdmin } from "../../../pages/admin/Board/BoardAdmin";

type AdminOption = { value: string; label: string };

type AdminSelectorProps = {
  admins: AdminOption[];
  setAdmins: (admins: AdminOption[]) => void;
};

export default function AdminSelector({
  admins,
  setAdmins,
}: AdminSelectorProps) {
  const handleAdminSelect = (
    selectedOptions: readonly AdminOption[] | null
  ) => {
    setAdmins(selectedOptions ? [...selectedOptions] : []);
  };

  const handleRemoveAdmin = (name: string) => {
    setAdmins(admins.filter((admin) => admin.label !== name));
  };

  const options: AdminOption[] = [
    { value: "admin1", label: "admin1" },
    { value: "admin2", label: "admin2" },
    { value: "admin3", label: "admin3" },
    { value: "admin4", label: "admin4" },
    { value: "admin5", label: "admin5" },
  ];

  return (
    <div className="mt-6">
      <p className="text-sm text-[#5F6B88] font-medium">Админы</p>
      <div className="mt-4 flex gap-2 flex-wrap">
        {admins.map((admin) => (
          <BoardAdmin
            key={admin.value}
            img={maleTeacher}
            name={admin.label}
            onRemove={() => handleRemoveAdmin(admin.label)}
          />
        ))}
      </div>

      <Select
        isMulti
        options={options}
        value={admins}
        onChange={handleAdminSelect}
        className="mt-4 !text-gray-500  !outline-none !rounded-lg"
        placeholder="Выберите администратора"
      />
    </div>
  );
}
